import type { CoreApiClient } from "../client";
import type { SignInRequestBody, SignInResponseBody } from "../types/auth.type";

export const createAuthMutations = ({ request }: CoreApiClient) => ({
  signIn: async (body: SignInRequestBody): Promise<SignInResponseBody> => {
    const { data } = await request("post", "/sign-in/email", { body });
    return data;
  },

  signOut: async (): Promise<void> => {
    await request("post", "/sign-out");
  },
});
